<template>
  <div v-if="zsmInfo">
    <div class="panel panel-default">
      <div class="panel-heading">
        追溯码信息（数据更新于：{{
          new Date(zsmInfo.updateTime).format("YYYY-MM-dd hh:mm:ss")
        }}）
      </div>
      <table class="table table-striped">
        <tbody>
          <tr>
            <th style="width: 90px">追溯码</th>
            <td colspan="3">
              {{ zsmInfo.code || "" }}
            </td>
          </tr>
          <tr>
            <th style="width: 90px">通用名称</th>
            <td colspan="3">
              {{ zsmInfo.genericName || "" }}
            </td>
          </tr>
          <tr>
            <th style="width: 90px">生产企业</th>
            <td colspan="3">
              {{ zsmInfo.manufacturer || "" }}
            </td>
          </tr>
          <tr v-if="!simpleMode">
            <th style="width: 90px">药品类型</th>
            <td>
              {{ zsmInfo.productType || "" }}
            </td>
            <th style="width: 90px">产品批号</th>
            <td>
              {{ zsmInfo.batchCode || "" }}
            </td>
          </tr>
          <tr v-if="!simpleMode">
            <th style="width: 90px">批准文号</th>
            <td>
              {{ zsmInfo.approvalNum || "" }}
            </td>
            <th style="width: 90px">剂型规格</th>
            <td>
              {{ zsmInfo.drugDosage || "" }}
            </td>
          </tr>
          <template v-else>
            <tr>
              <th style="width: 90px">批准文号</th>
              <td colspan="3">
                {{ zsmInfo.approvalNum || "" }}
              </td>
            </tr>
            <tr>
              <th style="width: 90px">剂型规格</th>
              <td colspan="3">
                {{ zsmInfo.drugDosage || "" }}
              </td>
            </tr>
          </template>
          <tr v-if="!simpleMode">
            <th style="width: 90px">生产日期</th>
            <td>
              {{ zsmInfo.productDate || "" }}
            </td>
            <th style="width: 90px">失效日期</th>
            <td>
              {{ zsmInfo.validDate || "" }}
            </td>
          </tr>
          <tr v-if="!simpleMode">
            <th style="width: 90px">产品规格</th>
            <td colspan="3">
              {{ zsmInfo.productSpec || "" }}
            </td>
          </tr>
          <tr v-if="!simpleMode">
            <th style="width: 90px">最小包装</th>
            <td>
              {{ zsmInfo.minPackUnit || "" }}
            </td>
            <th style="width: 90px">最小贴码</th>
            <td>
              {{ zsmInfo.minTagUnit || "" }}
            </td>
          </tr>
          <template v-else>
            <tr>
              <th style="width: 90px">最小包装</th>
              <td colspan="3">
                {{ zsmInfo.minPackUnit || "-" }}
              </td>
            </tr>
            <tr>
              <th style="width: 90px">最小贴码</th>
              <td colspan="3">
                {{ zsmInfo.minTagUnit || "-" }}
              </td>
            </tr>
          </template>
          <tr v-if="!simpleMode">
            <th style="width: 90px">贴码比例</th>
            <td>
              {{ zsmInfo.tagRatio || "" }}
            </td>
            <th style="width: 90px">贴码级别</th>
            <td>
              {{ zsmInfo.codeLevel || "-" }}
            </td>
          </tr>
          <tr>
            <th style="width: 90px">子码数量</th>
            <td colspan="3">
              {{ zsmInfo.childCount || "0" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <span style="color: #919191"> * 追溯信息来源于国家兽药产品追溯系统 </span>
  </div>
</template>


<script>
export default {
  props: {
    zsmInfo: {
      type: Object,
    },
    simpleMode: {
      type: Boolean,
      default: false,
    },
  },
}
</script>